(function () {
  'use strict';

  var CONFIG_ZONES = {
    'Solo Fronte': ['Fronte'],
    'Solo Retro': ['Retro'],
    'Fronte + Retro': ['Fronte', 'Retro'],
    'Completo 10 Pagine': [
      'Cover Fronte',
      'Cover Fronte Interno',
      'Pagina 1',
      'Pagina 2',
      'Pagina 3',
      'Pagina 4',
      'Pagina 5',
      'Pagina 6',
      'Cover Retro',
      'Cover Retro Interno'
    ]
  };

  var CONFIG_DESCRIPTIONS = {
    'Solo Fronte': 'Personalizza solo la parte frontale.',
    'Solo Retro': 'Personalizza solo il retro del gioiello.',
    'Fronte + Retro': 'Personalizza entrambi i lati del gioiello.',
    'Completo 10 Pagine': 'Personalizza cover, pagine interne e retro.'
  };

  var PERSONALIZATION_DESCRIPTIONS = {
    'Solo Testo': 'Perfetto per nomi, date o dediche.',
    'Foto + Testo': 'Aggiungi una foto speciale o una dedica.'
  };

  var CONFIG_ORDER = ['Solo Fronte', 'Solo Retro', 'Fronte + Retro', 'Completo 10 Pagine'];
  var PERSONALIZATION_ORDER = ['Solo Testo', 'Foto + Testo'];
  var ACCEPTED_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
  var DEFAULT_FONTS = [
    { name: 'Monotype Corsiva', style: 'script', image: '' },
    { name: 'Bungee Shade', style: 'shade', image: '' },
    { name: 'Carattere', style: 'script', image: '' },
    { name: 'Gabriela', style: 'serif', image: '' },
    { name: 'Lugrasimo', style: 'script', image: '' }
  ];

  function initPersonalizer(container) {
    var form = container.closest('form');
    var productScript = container.querySelector('[data-cryela-product-json]');
    if (!form || !productScript) return;

    form.setAttribute('enctype', 'multipart/form-data');

    var product = JSON.parse(productScript.textContent);
    var productShell = container.closest('.cryela-product');
    var submitButton = form.querySelector('[data-cryela-submit]');
    var mobileNavCta = document.querySelector('[data-cryela-nav-cta]');
    var messageEl = container.querySelector('[data-cryela-message]');
    var totalEl = container.querySelector('[data-cryela-total]');
    var summaryEl = container.querySelector('[data-cryela-summary]');
    var zonesEl = container.querySelector('[data-cryela-zones]');
    var variantInput = form.querySelector('input[name="id"]');

    var settings = {
      productTitle: container.dataset.productTitle || product.title || '',
      includedPhotos: parseInt(container.dataset.includedPhotos || '1', 10) || 1,
      maxFileSizeMb: parseInt(container.dataset.maxFileSizeMb || '8', 10) || 8,
      maxTextLength: parseInt(container.dataset.maxTextLength || '40', 10) || 40,
      extraVariantId: container.dataset.extraVariantId || '57427065602379',
      extraPriceCents: parseInt(container.dataset.extraPriceCents || '1450', 10) || 1450,
      fonts: parseFontOptions(container.dataset.fontOptions)
    };

    var optionIndexes = {
      color: findOptionIndex(product, ['Colore', 'Color', 'Colour'], 0),
      configuration: findOptionIndex(product, ['Configurazione', 'Configuration'], 1),
      personalization: findOptionIndex(product, ['Personalizzazione', 'Personalization'], 2)
    };

    var selectedVariant = findVariantById(product, container.dataset.selectedVariantId) || product.variants[0] || null;
    var state = {
      selected: {
        color: getVariantOption(selectedVariant, optionIndexes.color),
        configuration: getVariantOption(selectedVariant, optionIndexes.configuration),
        personalization: getVariantOption(selectedVariant, optionIndexes.personalization)
      },
      zones: {},
      selectedVariant: selectedVariant,
      isSubmitting: false
    };

    ensureInitialSelections();
    renderOptions();
    renderZones(true);
    updateAll();

    form.addEventListener('submit', handleSubmit);
    if (mobileNavCta) {
      mobileNavCta.href = '#CryelaProductForm';
      mobileNavCta.setAttribute('role', 'button');
      mobileNavCta.addEventListener('click', handleMobileNavSubmit);
    }

    function ensureInitialSelections() {
      if (!state.selected.color) state.selected.color = firstValueForIndex(optionIndexes.color);
      if (!state.selected.configuration) state.selected.configuration = firstValueForIndex(optionIndexes.configuration);
      if (!state.selected.personalization) state.selected.personalization = firstValueForIndex(optionIndexes.personalization);
    }

    function firstValueForIndex(index) {
      var values = valuesForIndex(index);
      return values[0] || '';
    }

    function renderOptions() {
      renderOptionGroup('Colore', 'color', valuesForIndex(optionIndexes.color));
      renderOptionGroup('Configurazione', 'configuration', valuesForIndex(optionIndexes.configuration));
      renderOptionGroup(
        'Personalizzazione',
        'personalization',
        orderedValues(valuesForIndex(optionIndexes.personalization), PERSONALIZATION_ORDER)
      );
    }

    function renderOptionGroup(optionName, stateKey, values) {
      var host = container.querySelector('[data-cryela-options="' + optionName + '"]');
      if (!host) return;

      host.innerHTML = '';
      values.forEach(function (value) {
        var button = document.createElement('button');
        var description = getDescription(optionName, value);
        button.type = 'button';
        button.className = 'cryela-personalizer__choice' + (state.selected[stateKey] === value ? ' is-active' : '');
        button.setAttribute('aria-pressed', state.selected[stateKey] === value ? 'true' : 'false');
        button.disabled = !hasVariantForPotentialSelection(stateKey, value);
        button.innerHTML =
          '<span class="cryela-personalizer__choice-title"></span>' +
          (description ? '<span class="cryela-personalizer__choice-description"></span>' : '');
        button.querySelector('.cryela-personalizer__choice-title').textContent = value;
        if (description) button.querySelector('.cryela-personalizer__choice-description').textContent = description;
        button.addEventListener('click', function () {
          if (button.disabled) return;
          var previousConfiguration = state.selected.configuration;
          var previousPersonalization = state.selected.personalization;
          state.selected[stateKey] = value;
          renderOptions();
          if (state.selected.configuration !== previousConfiguration || state.selected.personalization !== previousPersonalization) {
            renderZones(false);
          }
          updateAll();
        });
        host.appendChild(button);
      });
    }

    function renderZones(initialRender) {
      var zones = getZonesForConfiguration(state.selected.configuration);
      zonesEl.innerHTML = '';

      zones.forEach(function (zone) {
        if (!state.zones[zone]) {
          state.zones[zone] = {
            mode: state.selected.personalization === 'Solo Testo' ? 'Testo' : '',
            text: '',
            font: defaultFontName(),
            file: null,
            previewUrl: ''
          };
        }
        if (state.selected.personalization === 'Solo Testo') {
          clearZoneFile(zone);
          state.zones[zone].mode = 'Testo';
          ensureZoneFont(zone);
        } else if (!initialRender && state.zones[zone].mode === 'Testo') {
          state.zones[zone].mode = 'Testo';
          ensureZoneFont(zone);
        }

        zonesEl.appendChild(createZoneCard(zone));
      });

      updateAll();
    }

    function createZoneCard(zone) {
      var zoneState = state.zones[zone];
      var card = document.createElement('div');
      card.className = 'cryela-personalizer__zone';
      card.dataset.zone = zone;

      var head = document.createElement('div');
      head.className = 'cryela-personalizer__zone-head';
      var title = document.createElement('h4');
      title.className = 'cryela-personalizer__zone-title';
      title.textContent = zone;
      head.appendChild(title);
      card.appendChild(head);

      if (state.selected.personalization === 'Foto + Testo') {
        var mode = document.createElement('div');
        mode.className = 'cryela-personalizer__mode';
        mode.appendChild(createModeButton(zone, 'Foto'));
        mode.appendChild(createModeButton(zone, 'Testo'));
        card.appendChild(mode);
      }

      var field = document.createElement('div');
      field.className = 'cryela-personalizer__field';
      field.dataset.zoneField = zone;
      card.appendChild(field);

      var error = document.createElement('div');
      error.className = 'cryela-personalizer__error';
      error.dataset.zoneError = zone;
      card.appendChild(error);

      if (zoneState.mode === 'Foto') renderPhotoField(zone, field);
      if (zoneState.mode === 'Testo') renderTextField(zone, field);

      return card;
    }

    function createModeButton(zone, modeValue) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'cryela-personalizer__mode-button' + (state.zones[zone].mode === modeValue ? ' is-active' : '');
      button.textContent = modeValue;
      button.addEventListener('click', function () {
        if (state.zones[zone].mode === 'Foto' && modeValue !== 'Foto') clearZoneFile(zone);
        state.zones[zone].mode = modeValue;
        if (modeValue === 'Testo') ensureZoneFont(zone);
        clearZoneError(zone);
        updateZoneCard(zone);
      });
      return button;
    }

    function updateZoneCard(zone) {
      var card = zonesEl.querySelector('[data-zone="' + cssEscape(zone) + '"]');
      if (!card) {
        renderZones(true);
        return;
      }

      card.querySelectorAll('.cryela-personalizer__mode-button').forEach(function (button) {
        button.classList.toggle('is-active', button.textContent.trim() === state.zones[zone].mode);
      });

      var field = card.querySelector('[data-zone-field="' + cssEscape(zone) + '"]');
      if (!field) return;
      field.innerHTML = '';

      if (state.zones[zone].mode === 'Foto') renderPhotoField(zone, field);
      if (state.zones[zone].mode === 'Testo') renderTextField(zone, field);

      updateAll();
    }

    function renderTextField(zone, field) {
      ensureZoneFont(zone);
      var selectedFont = getSelectedFont(zone);

      var input = document.createElement('input');
      input.type = 'text';
      input.className = 'cryela-personalizer__text';
      input.name = 'properties[' + zone + ' - Testo]';
      input.placeholder = 'Scrivi qui il tuo testo';
      input.maxLength = settings.maxTextLength;
      input.value = state.zones[zone].text || '';
      input.addEventListener('input', function () {
        state.zones[zone].text = input.value;
        if (fontInput) fontInput.disabled = !input.value.trim();
        clearZoneError(zone);
        updateAll();
      });
      field.appendChild(input);
      field.appendChild(createFontSelector(zone));

      var fontInput = document.createElement('input');
      fontInput.type = 'hidden';
      fontInput.name = 'properties[' + zone + ' - Font]';
      fontInput.value = selectedFont.name;
      fontInput.disabled = !String(state.zones[zone].text || '').trim();
      fontInput.dataset.fontInput = zone;
      field.appendChild(fontInput);
    }

    function createFontSelector(zone) {
      var wrap = document.createElement('div');
      wrap.className = 'cryela-personalizer__font-picker';

      var label = document.createElement('p');
      label.className = 'cryela-personalizer__font-label';
      label.textContent = 'Scegli il font';
      wrap.appendChild(label);

      var grid = document.createElement('div');
      grid.className = 'cryela-personalizer__font-grid';
      wrap.appendChild(grid);

      settings.fonts.forEach(function (font) {
        var button = document.createElement('button');
        var active = state.zones[zone].font === font.name;
        button.type = 'button';
        button.className = 'cryela-personalizer__font-choice cryela-personalizer__font-choice--' + font.style + (active ? ' is-active' : '');
        button.setAttribute('aria-pressed', active ? 'true' : 'false');

        var image = document.createElement('img');
        image.className = 'cryela-personalizer__font-image';
        image.src = font.image || buildFontPreviewImage(font);
        image.alt = font.name;
        image.loading = 'lazy';
        button.appendChild(image);

        var name = document.createElement('span');
        name.className = 'cryela-personalizer__font-name';
        name.textContent = font.name;
        button.appendChild(name);

        button.addEventListener('click', function () {
          state.zones[zone].font = font.name;
          updateZoneCard(zone);
        });

        grid.appendChild(button);
      });

      return wrap;
    }

    function renderPhotoField(zone, field) {
      var zoneState = state.zones[zone];
      var upload = document.createElement('div');
      var inputId = 'CryelaPhoto-' + slugify(zone);
      upload.className = 'cryela-personalizer__upload' + (zoneState.file ? ' has-file' : '');

      var input = document.createElement('input');
      input.type = 'file';
      input.id = inputId;
      input.className = 'cryela-personalizer__file';
      input.name = 'properties[' + zone + ' - Foto]';
      input.accept = 'image/jpeg,image/png,image/webp';

      var preview = document.createElement('img');
      preview.className = 'cryela-personalizer__preview';
      preview.alt = zone;
      if (zoneState.previewUrl) preview.src = zoneState.previewUrl;

      var copy = document.createElement('p');
      copy.className = 'cryela-personalizer__upload-copy';
      copy.textContent = zoneState.file ? zoneState.file.name : 'JPG, PNG o WEBP fino a ' + settings.maxFileSizeMb + ' MB';

      var actions = document.createElement('div');
      actions.className = 'cryela-personalizer__upload-actions';
      var label = document.createElement('label');
      label.className = 'cryela-personalizer__upload-button';
      label.htmlFor = inputId;
      label.textContent = zoneState.file ? 'Cambia foto' : 'Carica foto';
      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'cryela-personalizer__remove';
      remove.textContent = 'Rimuovi';
      remove.hidden = !zoneState.file;

      input.addEventListener('change', function () {
        var file = input.files && input.files[0] ? input.files[0] : null;
        if (!file) return;
        var error = validateFile(file);
        if (error) {
          input.value = '';
          clearZoneFile(zone);
          setZoneError(zone, error);
          renderZones(true);
          return;
        }
        clearZoneError(zone);
        setZoneFile(zone, file);
        preview.src = state.zones[zone].previewUrl;
        upload.classList.add('has-file');
        copy.textContent = file.name;
        label.textContent = 'Cambia foto';
        remove.hidden = false;
        updateAll();
      });

      remove.addEventListener('click', function () {
        input.value = '';
        clearZoneFile(zone);
        clearZoneError(zone);
        renderZones(true);
      });

      actions.appendChild(label);
      actions.appendChild(remove);
      upload.appendChild(input);
      upload.appendChild(preview);
      upload.appendChild(copy);
      upload.appendChild(actions);

      var note = document.createElement('div');
      note.className = 'cryela-personalizer__extra-note';
      note.dataset.extraNote = zone;

      field.appendChild(upload);
      field.appendChild(note);
    }

    function updateAll() {
      state.selectedVariant = resolveSelectedVariant();
      updateVariantInput();
      updateProductPrice();
      updateVariantImage();
      updateTotals();
      updateSummary();
      updateHiddenProperties();
      updateSubmitState();
      updateExtraNotes();
    }

    function resolveSelectedVariant() {
      return product.variants.find(function (variant) {
        return (
          getVariantOption(variant, optionIndexes.color) === state.selected.color &&
          getVariantOption(variant, optionIndexes.configuration) === state.selected.configuration &&
          getVariantOption(variant, optionIndexes.personalization) === state.selected.personalization
        );
      }) || null;
    }

    function updateVariantInput() {
      if (variantInput && state.selectedVariant) variantInput.value = state.selectedVariant.id;
    }

    function updateProductPrice() {
      if (!state.selectedVariant || !productShell) return;
      var priceMain = productShell.querySelector('[data-cryela-price-main]');
      var priceCompare = productShell.querySelector('[data-cryela-price-compare]');
      if (priceMain) priceMain.textContent = formatMoney(state.selectedVariant.price);
      if (priceCompare) {
        var compare = state.selectedVariant.compare_at_price || 0;
        if (compare > state.selectedVariant.price) {
          priceCompare.innerHTML = '<s>' + formatMoney(compare) + '</s>';
          priceCompare.style.display = '';
        } else {
          priceCompare.style.display = 'none';
        }
      }
    }

    function updateVariantImage() {
      if (!state.selectedVariant || !productShell) return;
      var imageId = variantImageId(state.selectedVariant);
      if (!imageId) return;
      var frame = productShell.querySelector('[data-cryela-frame="' + imageId + '"]');
      var track = productShell.querySelector('[data-cryela-track]');
      if (frame) {
        if (track && typeof track.scrollTo === 'function') {
          track.scrollTo({ left: frame.offsetLeft, behavior: 'smooth' });
        } else if (track) {
          track.scrollLeft = frame.offsetLeft;
        }
      }
      productShell.querySelectorAll('[data-cryela-thumb]').forEach(function (thumb) {
        thumb.classList.toggle('is-active', String(thumb.dataset.cryelaImageId) === String(imageId));
      });
    }

    function updateTotals() {
      var total = getTotalCents();
      if (totalEl) totalEl.textContent = formatMoney(total);
      if (submitButton) submitButton.textContent = state.isSubmitting ? 'Caricamento in corso...' : 'Aggiungi al carrello — ' + formatMoney(total);
      if (mobileNavCta) {
        if (state.isSubmitting) {
          mobileNavCta.textContent = 'Caricamento in corso...';
        } else {
          mobileNavCta.innerHTML =
            '<span class="cryela-bottom-nav__cta-label">Aggiungi al carrello</span>' +
            '<span class="cryela-bottom-nav__cta-price">' + formatMoney(total) + '</span>';
          mobileNavCta.setAttribute('aria-label', 'Aggiungi al carrello — ' + formatMoney(total));
        }
      }
    }

    function updateSubmitState() {
      if (!submitButton || state.isSubmitting) return;
      var unavailable = !state.selectedVariant || state.selectedVariant.available === false;
      submitButton.disabled = unavailable;
      if (mobileNavCta) {
        mobileNavCta.classList.toggle('is-disabled', unavailable);
        mobileNavCta.setAttribute('aria-disabled', unavailable ? 'true' : 'false');
      }
      if (unavailable) showMessage('Questa combinazione non è disponibile.', true);
      else if (messageEl && messageEl.textContent === 'Questa combinazione non è disponibile.') showMessage('', false);
    }

    function handleMobileNavSubmit(event) {
      event.preventDefault();
      if (mobileNavCta.getAttribute('aria-disabled') === 'true') return;
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(submitButton || undefined);
      } else if (submitButton) {
        submitButton.click();
      }
    }

    function updateSummary() {
      var rows = buildSummaryRows();
      summaryEl.innerHTML = '';
      if (!rows.length) {
        var empty = document.createElement('p');
        empty.className = 'cryela-personalizer__summary-empty';
        empty.textContent = 'Completa la personalizzazione prima di aggiungere il prodotto al carrello.';
        summaryEl.appendChild(empty);
        return;
      }

      rows.forEach(function (row) {
        var line = document.createElement('div');
        line.className = 'cryela-personalizer__summary-row';
        var label = document.createElement('strong');
        var value = document.createElement('span');
        label.textContent = row.label + ':';
        if (row.previewUrl) {
          var image = document.createElement('img');
          image.className = 'cryela-personalizer__summary-preview';
          image.src = row.previewUrl;
          image.alt = row.label;
          value.appendChild(image);
          value.appendChild(document.createTextNode(row.value));
        } else {
          value.textContent = row.value;
        }
        line.appendChild(label);
        line.appendChild(value);
        summaryEl.appendChild(line);
      });
    }

    function buildSummaryRows() {
      var rows = [];
      if (state.selected.color) rows.push({ label: 'Colore scelto', value: state.selected.color });
      if (state.selected.configuration) rows.push({ label: 'Configurazione', value: state.selected.configuration });
      if (state.selected.personalization) rows.push({ label: 'Personalizzazione', value: state.selected.personalization });

      submissionZones().forEach(function (zone) {
        var zoneState = state.zones[zone];
        if (!zoneState) return;
        if (zoneState.mode === 'Foto' && zoneState.file) {
          rows.push({ label: zone, value: 'Foto caricata', previewUrl: zoneState.previewUrl });
        }
        if (zoneState.mode === 'Testo' && zoneState.text.trim()) {
          rows.push({ label: zone, value: 'Testo "' + zoneState.text.trim() + '"' });
          rows.push({ label: zone + ' - Font', value: zoneState.font || defaultFontName() });
        }
      });

      var extraPhotos = getExtraPhotoCount();
      if (extraPhotos > 0) {
        rows.push({ label: 'Foto extra', value: String(extraPhotos) });
        rows.push({ label: 'Supplemento foto extra', value: formatMoney(extraPhotos * settings.extraPriceCents) });
      }
      rows.push({ label: 'Totale', value: formatMoney(getTotalCents()) });
      return rows;
    }

    function updateHiddenProperties() {
      var extraPhotos = getExtraPhotoCount();
      setHiddenProperty('color', state.selected.color || '');
      setHiddenProperty('configuration', state.selected.configuration || '');
      setHiddenProperty('personalization', state.selected.personalization || '');
      setHiddenProperty('extraPhotos', extraPhotos > 0 ? String(extraPhotos) : '', extraPhotos === 0);
      setHiddenProperty('extraSupplement', extraPhotos > 0 ? formatMoney(extraPhotos * settings.extraPriceCents) : '', extraPhotos === 0);
      setHiddenProperty('fonts', buildFontsText(), !buildFontsText());
      setHiddenProperty('summary', buildSummaryText());
    }

    function buildSummaryText() {
      return buildSummaryRows()
        .map(function (row) {
          return row.label + ': ' + row.value;
        })
        .join(' | ');
    }

    function buildFontsText() {
      return submissionZones()
        .map(function (zone) {
          var zoneState = state.zones[zone];
          if (!zoneState || zoneState.mode !== 'Testo' || !zoneState.text.trim()) return '';
          return zone + ': ' + (zoneState.font || defaultFontName());
        })
        .filter(Boolean)
        .join(' | ');
    }

    function setHiddenProperty(key, value, disabled) {
      var input = container.querySelector('[data-cryela-property="' + key + '"]');
      if (!input) return;
      input.value = value;
      input.disabled = Boolean(disabled);
    }

    function updateExtraNotes() {
      var photoZones = submissionZones().filter(function (zone) {
        return state.zones[zone] && state.zones[zone].mode === 'Foto' && state.zones[zone].file;
      });
      activeZones().forEach(function (zone) {
        var note = container.querySelector('[data-extra-note="' + cssEscape(zone) + '"]');
        if (note) note.textContent = '';
      });
      photoZones.forEach(function (zone, index) {
        if (index < settings.includedPhotos) return;
        var note = container.querySelector('[data-extra-note="' + cssEscape(zone) + '"]');
        if (note) note.textContent = 'Questa immagine richiede una lavorazione extra. Supplemento applicato: ' + formatMoney(settings.extraPriceCents) + '.';
      });
    }

    function handleSubmit(event) {
      if (form.dataset.cryelaNativeSubmit === 'true') return;
      event.preventDefault();
      if (state.isSubmitting) return;

      var valid = validateBeforeSubmit();
      if (!valid) {
        showMessage('Completa la personalizzazione prima di aggiungere il prodotto al carrello.', true);
        return;
      }

      state.isSubmitting = true;
      if (submitButton) submitButton.disabled = true;
      if (mobileNavCta) {
        mobileNavCta.classList.add('is-disabled');
        mobileNavCta.setAttribute('aria-disabled', 'true');
      }
      updateTotals();
      showMessage('', false);

      addToCart()
        .then(function () {
          showMessage('Personalizzazione aggiunta al carrello.', false);
          openCartAfterAdd();
        })
        .catch(function (error) {
          console.error(error);
          /* Disable empty nota before native submit so it is not sent */
          var notaInput = form.querySelector('[data-cryela-nota]');
          if (notaInput && notaInput.value.trim() === '') {
            notaInput.disabled = true;
          }
          form.dataset.cryelaNativeSubmit = 'true';
          form.submit();
        })
        .finally(function () {
          state.isSubmitting = false;
          updateTotals();
          updateSubmitState();
        });
    }

    function validateBeforeSubmit() {
      var valid = true;
      clearAllZoneErrors();

      if (!state.selectedVariant || state.selectedVariant.available === false) return false;
      if (!state.selected.color || !state.selected.configuration || !state.selected.personalization) return false;

      var completedZones = 0;
      submissionZones().forEach(function (zone) {
        var zoneState = state.zones[zone];
        if (!zoneState) return;
        if (zoneState.mode === 'Foto') {
          if (!zoneState.file) {
            setZoneError(zone, 'Completa la personalizzazione prima di aggiungere il prodotto al carrello.');
            valid = false;
            return;
          }
          var fileError = validateFile(zoneState.file);
          if (fileError) {
            setZoneError(zone, fileError);
            valid = false;
            return;
          }
          completedZones += 1;
        }
        if (zoneState.mode === 'Testo' && zoneState.text.trim()) {
          completedZones += 1;
        } else if (zoneState.mode === 'Testo' && state.selected.personalization === 'Foto + Testo') {
          setZoneError(zone, 'Completa la personalizzazione prima di aggiungere il prodotto al carrello.');
          valid = false;
        }
      });

      if (completedZones < 1) valid = false;
      return valid;
    }

    async function addToCart() {
      updateHiddenProperties();
      var sections = getCartSectionIds();
      var formData = new FormData(form);
      appendStateFilesToFormData(formData);
      appendStateTextDetailsToFormData(formData);
      removeEmptyNota(formData);
      if (state.selectedVariant) formData.set('id', state.selectedVariant.id);
      if (sections) formData.set('sections', sections);
      if (getExtraPhotoCount() === 0) {
        formData.delete('properties[Numero foto extra]');
        formData.delete('properties[Supplemento foto extra]');
      }

      var mainResponse = await postCartAdd(formData);
      var lastSections = mainResponse.sections || {};
      var extraPhotos = getExtraPhotoCount();

      if (extraPhotos > 0) {
        var extraData = new FormData();
        extraData.set('id', settings.extraVariantId);
        extraData.set('quantity', String(extraPhotos));
        extraData.set('properties[Collegato a]', settings.productTitle);
        extraData.set('properties[Motivo]', 'Foto extra personalizzazione');
        extraData.set('properties[Numero foto extra]', String(extraPhotos));
        extraData.set('properties[_cryela_locked]', 'true');
        if (sections) extraData.set('sections', sections);
        var extraResponse = await postCartAdd(extraData);
        lastSections = extraResponse.sections || lastSections;
      }

      var cart = await fetchCart();
      var displayItemCount = getVisibleCartCount(cart);
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'cryela-personalizer',
            data: {
              source: 'cryela-personalizer',
              itemCount: displayItemCount,
              displayItemCount: displayItemCount,
              sections: lastSections
            }
          }
        })
      );
    }

    function postCartAdd(body) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: body
      }).then(function (response) {
        return response.json().then(function (json) {
          if (!response.ok || json.status) {
            var message = json.description || json.message || 'Cart add failed';
            throw new Error(message);
          }
          return json;
        });
      });
    }

    function getVisibleCartCount(cart) {
      if (!cart || !cart.items) return cart && cart.item_count ? cart.item_count : 0;
      return cart.items.reduce(function (count, item) {
        var properties = item.properties || {};
        var isExtraPhoto =
          Number(item.variant_id) === Number(settings.extraVariantId) ||
          properties._cryela_locked === 'true' ||
          properties.Motivo === 'Foto extra personalizzazione';
        return count - (isExtraPhoto ? Number(item.quantity || 0) : 0);
      }, Number(cart.item_count || 0));
    }

    function appendStateFilesToFormData(formData) {
      submissionZones().forEach(function (zone) {
        var propertyName = 'properties[' + zone + ' - Foto]';
        formData.delete(propertyName);
        if (state.zones[zone] && state.zones[zone].mode === 'Foto' && state.zones[zone].file) {
          formData.append(propertyName, state.zones[zone].file, state.zones[zone].file.name);
        }
      });
    }

    function appendStateTextDetailsToFormData(formData) {
      submissionZones().forEach(function (zone) {
        var textProperty = 'properties[' + zone + ' - Testo]';
        var fontProperty = 'properties[' + zone + ' - Font]';
        var zoneState = state.zones[zone];
        formData.delete(textProperty);
        formData.delete(fontProperty);

        if (!zoneState || zoneState.mode !== 'Testo' || !zoneState.text.trim()) return;

        formData.set(textProperty, zoneState.text.trim());
        formData.set(fontProperty, zoneState.font || defaultFontName());
      });

      var fontsText = buildFontsText();
      if (fontsText) {
        formData.set('properties[Font personalizzazione]', fontsText);
      } else {
        formData.delete('properties[Font personalizzazione]');
      }
    }

    /**
     * Remove the Nota Ordine property from FormData when the field is empty.
     * This ensures an unfilled note never appears in the cart or order.
     */
    function removeEmptyNota(formData) {
      var val = formData.get('properties[Nota ordine]');
      if (val !== null && val.trim() === '') {
        formData.delete('properties[Nota ordine]');
      }
    }

    /**
     * Live character counter for the Nota Ordine textarea.
     */
    function initNotaCounter() {
      var textarea = form.querySelector('[data-cryela-nota]');
      var counter  = form.querySelector('[data-cryela-nota-chars]');
      if (!textarea || !counter) return;
      textarea.addEventListener('input', function () {
        counter.textContent = textarea.value.length;
      });
    }
    initNotaCounter();

    function fetchCart() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (response) {
        if (!response.ok) throw new Error('Cart fetch failed');
        return response.json();
      });
    }

    function openCartAfterAdd() {
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer) {
        if (typeof drawer.open === 'function') drawer.open();
        else if (typeof drawer.showDialog === 'function') drawer.showDialog();
        return;
      }
      window.location.href = '/cart';
    }

    function validateFile(file) {
      if (ACCEPTED_TYPES.indexOf(file.type) === -1) {
        return 'Formato non supportato. Carica una foto JPG, PNG o WEBP.';
      }
      if (file.size > settings.maxFileSizeMb * 1024 * 1024) {
        return 'La foto è troppo grande. Carica un’immagine fino a ' + settings.maxFileSizeMb + ' MB.';
      }
      return '';
    }

    function setZoneFile(zone, file) {
      clearZoneFile(zone);
      state.zones[zone].file = file;
      state.zones[zone].previewUrl = URL.createObjectURL(file);
    }

    function clearZoneFile(zone) {
      var zoneState = state.zones[zone];
      if (!zoneState) return;
      if (zoneState.previewUrl) URL.revokeObjectURL(zoneState.previewUrl);
      zoneState.file = null;
      zoneState.previewUrl = '';
    }

    function ensureZoneFont(zone) {
      if (!state.zones[zone]) return;
      if (!state.zones[zone].font || !fontByName(state.zones[zone].font)) {
        state.zones[zone].font = defaultFontName();
      }
    }

    function getSelectedFont(zone) {
      ensureZoneFont(zone);
      return fontByName(state.zones[zone].font) || settings.fonts[0] || DEFAULT_FONTS[0];
    }

    function fontByName(name) {
      return settings.fonts.find(function (font) {
        return font.name === name;
      }) || null;
    }

    function defaultFontName() {
      return settings.fonts[0] ? settings.fonts[0].name : DEFAULT_FONTS[0].name;
    }

    function activeZones() {
      return getZonesForConfiguration(state.selected.configuration);
    }

    function submissionZones() {
      var zones = activeZones().slice();
      if (!isPageZoneLabel(state.selected.configuration)) return zones;

      Object.keys(state.zones).forEach(function (zone) {
        if (zones.indexOf(zone) === -1 && hasZoneContent(state.zones[zone])) {
          zones.push(zone);
        }
      });
      return zones;
    }

    function hasZoneContent(zoneState) {
      if (!zoneState) return false;
      if (zoneState.mode === 'Foto') return Boolean(zoneState.file);
      if (zoneState.mode === 'Testo') return Boolean(String(zoneState.text || '').trim());
      return false;
    }

    function getUploadedPhotoCount() {
      return submissionZones().filter(function (zone) {
        return state.zones[zone] && state.zones[zone].mode === 'Foto' && state.zones[zone].file;
      }).length;
    }

    function getExtraPhotoCount() {
      return Math.max(0, getUploadedPhotoCount() - settings.includedPhotos);
    }

    function getTotalCents() {
      var basePrice = state.selectedVariant ? state.selectedVariant.price : 0;
      return basePrice + getExtraPhotoCount() * settings.extraPriceCents;
    }

    function setZoneError(zone, text) {
      var error = container.querySelector('[data-zone-error="' + cssEscape(zone) + '"]');
      if (error) error.textContent = text;
    }

    function clearZoneError(zone) {
      setZoneError(zone, '');
    }

    function clearAllZoneErrors() {
      container.querySelectorAll('[data-zone-error]').forEach(function (error) {
        error.textContent = '';
      });
    }

    function showMessage(text, isError) {
      if (!messageEl) return;
      messageEl.textContent = text || '';
      messageEl.classList.toggle('is-error', Boolean(isError));
    }

    function getCartSectionIds() {
      var ids = [];
      document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (component) {
        if (component.dataset.sectionId && ids.indexOf(component.dataset.sectionId) === -1) {
          ids.push(component.dataset.sectionId);
        }
      });
      return ids.join(',');
    }

    function valuesForIndex(index) {
      if (index < 0) return [];
      var values = [];
      product.variants.forEach(function (variant) {
        var value = getVariantOption(variant, index);
        if (value && value !== 'Default Title' && values.indexOf(value) === -1) values.push(value);
      });
      return values;
    }

    function orderedValues(values, order) {
      return values.slice().sort(function (a, b) {
        var ai = order.indexOf(a);
        var bi = order.indexOf(b);
        if (ai === -1 && bi === -1) return 0;
        if (ai === -1) return 1;
        if (bi === -1) return -1;
        return ai - bi;
      });
    }

    function hasVariantForPotentialSelection(key, value) {
      var selected = {
        color: state.selected.color,
        configuration: state.selected.configuration,
        personalization: state.selected.personalization
      };
      selected[key] = value;
      return product.variants.some(function (variant) {
        return (
          (!selected.color || getVariantOption(variant, optionIndexes.color) === selected.color) &&
          (!selected.configuration || getVariantOption(variant, optionIndexes.configuration) === selected.configuration) &&
          (!selected.personalization || getVariantOption(variant, optionIndexes.personalization) === selected.personalization)
        );
      });
    }

    function getDescription(optionName, value) {
      if (optionName === 'Configurazione') return CONFIG_DESCRIPTIONS[value] || '';
      if (optionName === 'Personalizzazione') return PERSONALIZATION_DESCRIPTIONS[value] || '';
      return '';
    }
  }

  function findOptionIndex(product, names, fallback) {
    var options = product.options || [];
    var targets = (Array.isArray(names) ? names : [names]).map(normalize);
    for (var i = 0; i < options.length; i += 1) {
      var optionName = normalize(options[i]);
      if (targets.indexOf(optionName) !== -1) return i;
    }
    for (var j = 0; j < options.length; j += 1) {
      var looseOptionName = normalize(options[j]);
      if (targets.some(function (target) { return looseOptionName.indexOf(target) !== -1; })) return j;
    }
    return typeof fallback === 'number' && fallback < options.length ? fallback : -1;
  }

  function parseFontOptions(raw) {
    var parsed = String(raw || '')
      .split(/\r?\n/)
      .map(function (line) {
        var parts = line.split('|').map(function (part) {
          return part.trim();
        });
        var name = parts[0];
        if (!name) return null;
        var style = parts[1];
        var image = parts[2] || '';

        if (parts.length >= 4 || (parts.length === 3 && !isFontStyle(parts[1]) && isFontStyle(parts[2]))) {
          style = parts[2];
          image = parts[3] || '';
        }

        return {
          name: name,
          style: sanitizeFontStyle(style),
          image: image
        };
      })
      .filter(Boolean);

    return parsed.length ? parsed : DEFAULT_FONTS;
  }

  function buildFontPreviewImage(font) {
    var text = escapeSvgText(font.name);
    var style = font.style || 'script';
    var css = {
      script: "font-family: 'Brush Script MT', 'Segoe Script', cursive; font-style: italic; font-size: 29px;",
      shade: "font-family: Impact, 'Arial Black', sans-serif; font-size: 24px; font-weight: 900; letter-spacing: 1px;",
      serif: "font-family: Georgia, 'Times New Roman', serif; font-size: 28px; font-weight: 600;",
      bold: "font-family: Arial, sans-serif; font-size: 24px; font-weight: 800; letter-spacing: 1px;"
    }[style] || "font-family: Georgia, serif; font-size: 26px;";
    var paint = style === 'shade'
      ? 'fill="#fff7ec" stroke="#432324" stroke-width="1"'
      : 'fill="#432324"';
    var shadow = style === 'shade'
      ? '<text x="50%" y="52%" text-anchor="middle" dominant-baseline="middle" fill="#9d1d31" opacity=".48" transform="translate(3 3)" style="' + css + '">' + text + '</text>'
      : '';
    var svg =
      '<svg xmlns="http://www.w3.org/2000/svg" width="360" height="92" viewBox="0 0 360 92">' +
      '<rect width="360" height="92" rx="18" fill="#fffaf4"/>' +
      '<rect x="7" y="7" width="346" height="78" rx="15" fill="#ffffff" stroke="#ead8cf"/>' +
      shadow +
      '<text x="50%" y="52%" text-anchor="middle" dominant-baseline="middle" ' + paint + ' style="' + css + '">' + text + '</text>' +
      '</svg>';

    return 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg);
  }

  function escapeSvgText(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function sanitizeFontStyle(style) {
    var value = normalize(style) || 'script';
    return isFontStyle(value) ? value : 'script';
  }

  function isFontStyle(style) {
    return ['script', 'shade', 'serif', 'bold'].indexOf(normalize(style)) !== -1;
  }

  function getZonesForConfiguration(configuration) {
    if (CONFIG_ZONES[configuration]) return CONFIG_ZONES[configuration];

    var normalized = normalize(configuration);
    if (!normalized) return [];
    if (isPageZoneLabel(configuration)) return [configuration];

    if (normalized.indexOf('completo') !== -1 || normalized.indexOf('10') !== -1) {
      return CONFIG_ZONES['Completo 10 Pagine'];
    }
    if (normalized.indexOf('fronte') !== -1 && normalized.indexOf('retro') !== -1) {
      return CONFIG_ZONES['Fronte + Retro'];
    }
    if (normalized.indexOf('retro') !== -1) {
      return ['Retro'];
    }
    if (normalized.indexOf('fronte') !== -1 || normalized.indexOf('front') !== -1) {
      return ['Fronte'];
    }

    return [configuration];
  }

  function isPageZoneLabel(value) {
    var normalized = normalize(value);
    return (
      normalized.indexOf('pagina') !== -1 ||
      normalized.indexOf('page') !== -1 ||
      normalized.indexOf('cover') !== -1 ||
      normalized.indexOf('copert') !== -1
    );
  }

  function getVariantOption(variant, index) {
    if (!variant || index < 0 || !variant.options) return '';
    return variant.options[index] || '';
  }

  function findVariantById(product, id) {
    if (!id) return null;
    return product.variants.find(function (variant) {
      return String(variant.id) === String(id);
    }) || null;
  }

  function variantImageId(variant) {
    if (variant.featured_image && variant.featured_image.id) return variant.featured_image.id;
    if (variant.featured_media && variant.featured_media.id) return variant.featured_media.id;
    return '';
  }

  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function slugify(value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(value);
    return String(value).replace(/"/g, '\\"');
  }

  function formatMoney(cents) {
    return '€' + ((Number(cents) || 0) / 100).toLocaleString('it-IT', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function init() {
    document.querySelectorAll('[data-cryela-personalizer]').forEach(initPersonalizer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
